import { useEffect, useRef } from 'react';

import { useMeControllerRegistrarHeartbeat } from '@/api/generated/me/me';

/** A cada 60s — o teto de `AtividadeService` (2 min por ping) tolera folga sem perder tempo real. */
const INTERVALO_MS = 60_000;

/**
 * Heartbeat de atividade (B15-2) — alimenta o relatório "Tempo ativo" do
 * admin. Só soma minutos com a aba VISÍVEL (Page Visibility API): uma aba em
 * segundo plano não deveria contar como "usando o sistema".
 *
 * `ativo=false` quando não há sessão — nada de heartbeat de visitante anônimo.
 */
export function useHeartbeatDeAtividade(ativo: boolean): void {
  const heartbeat = useMeControllerRegistrarHeartbeat();

  // `useRef`: o listener é montado uma vez, e capturar a mutation daquele
  // render deixaria o callback preso à primeira closure (mesmo padrão de
  // `useTrackingParceiro`).
  const heartbeatRef = useRef(heartbeat);
  heartbeatRef.current = heartbeat;

  useEffect(() => {
    if (!ativo) return;

    function enviar() {
      if (document.visibilityState !== 'visible') return;
      // Falha de telemetria não pode virar erro na tela — não há o que o
      // usuário faça com "não consegui registrar sua atividade".
      heartbeatRef.current.mutate(undefined, { onError: () => undefined });
    }

    enviar();
    const id = setInterval(enviar, INTERVALO_MS);
    document.addEventListener('visibilitychange', enviar);

    return () => {
      clearInterval(id);
      document.removeEventListener('visibilitychange', enviar);
    };
  }, [ativo]);
}
